import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'
import { Loader } from 'semantic-ui-react'
import { URLHelper, ViewerContext } from 'shared'

export const useRedirectIfSignedIn = () => {
  const location = useLocation()
  const { viewer, viewerLoading } = useContext(ViewerContext)
  // `return_to` routinely points outside the SPA at a server-rendered page. A
  // React Router <Navigate> matches no route there and renders a blank page, so
  // hand the path to the browser instead, exactly like the sign-in form itself
  // does on success.
  const target = viewerLoading || !viewer ? null : URLHelper.returnToPath(location)

  useEffect(() => {
    if (target) window.location.replace(target)
  }, [target])

  if (viewerLoading || viewer) return <Loader active />
  return null
}
